export default __webpack_public_path__ + "static/media/finger-swipe.fb37421c.svg";